import { useTranslation } from 'react-i18next';
import { LevelBadge } from 'shared-ui/lib/components/LevelBadge';
import { getAssignableUserLevelOptions } from '../data/get-user-level-options';
import { useCan, UserLevel } from '../hooks/use-can';

type UpdateLevelFn = (opt: {
  variables: { body: { userId: string; level: string } };
}) => void;

type Props = {
  user: {
    id: string;
    level?: string | null;
    isPartnerAccountOwner?: boolean | null;
  };
  onUpdate: UpdateLevelFn;
};

export const UserLevelCell = ({ user, onUpdate }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { canManageUsers } = useCan();
  const isMasterRow =
    !!user.isPartnerAccountOwner || user.level === UserLevel.MASTER;

  if (isMasterRow || !canManageUsers) {
    return <LevelBadge level={user.level} />;
  }

  return (
    <select
      className="border-gray-300 rounded-md shadow-sm text-sm focus:ring-secondary focus:border-secondary"
      value={user.level ?? UserLevel.BASIC}
      onChange={(e) =>
        onUpdate({
          variables: { body: { userId: user.id, level: e.target.value } },
        })
      }
    >
      {getAssignableUserLevelOptions().map((opt) => (
        <option key={opt.value} value={opt.value}>
          {t(opt.label)}
        </option>
      ))}
    </select>
  );
};
